// 🎯 B227 (AI_114) — Categorias do erro apontado na calibração do semáforo.
// Quando o médico marca "Parcial"/"Discordo", ele classifica O QUE estava errado
// na análise da IA. A agregação (DashboardInsightsIA) vira um backlog rastreável
// de "qual regra/dimensão endurecer" — atende o monitoramento contínuo exigido
// pela Res. CFM 2.454/2026. Fonte única (captura + dashboard).
//
// Lista editável por Leonardo: refletem as regras do verificador + erros clínicos
// comuns. Acrescentar/renomear é seguro (o valor é a chave persistida).

export interface CategoriaErro {
  valor: string;
  label: string;
}

export const CATEGORIAS_ERRO_CALIBRACAO: CategoriaErro[] = [
  { valor: "numero_data", label: "Número/data/medida incorreta" },
  { valor: "citacao", label: "Citação de diretriz não ancorada/imprecisa" },
  { valor: "omissao", label: "Omitiu achado/dado relevante" },
  { valor: "conduta", label: "Conduta/recomendação indevida ou ausente" },
  { valor: "escore_postx", label: "MELD/escore aplicado indevidamente (pós-Tx)" },
  { valor: "estadiamento", label: "Estadiamento/classificação incorreto" },
  { valor: "interpretacao", label: "Interpretação clínica equivocada" },
  { valor: "forma", label: "Forma/redação (não-clínico)" },
  { valor: "outro", label: "Outro" },
];

const MAPA = CATEGORIAS_ERRO_CALIBRACAO.reduce<Record<string, string>>(
  (acc, c) => {
    acc[c.valor] = c.label;
    return acc;
  },
  {}
);

export function labelCategoriaErro(valor: string | null | undefined): string {
  if (!valor) return "—";
  return MAPA[valor] || valor;
}
